import { Grid, Img, Typography } from '@lingoda/ui';
import { ssl } from '../../assets/media';

interface Props {
    message?: string;
}

export const SslFooter = ({ message }: Props) => (
    <Grid wrap="nowrap" container alignItems="center" justifyContent={['center', 'flex-start']}>
        <Grid item>
            <Img src={ssl} />
        </Grid>
        <Grid item pl={1}>
            <Typography>
                <i>{message}</i>
            </Typography>
        </Grid>
    </Grid>
);
